import logo from "../../assets/images/background/tasa-logo.1310fb7d1165012747a3cde3fb11ff4f.svg"
import linesGreen from "../../assets/images/background/figure-lines.dfc64c854de9ceb1c09b247f4d52d51b.svg"
import figureLightBlue from "../../assets/images/background/figure-light-blue.b8d0700d6ec4301c6fae01a78b413f1f.svg"
import figureBlue from "../../assets/images/background/figure-blue.e064f22fbdd783a20b005f2e92ecc6d4.svg"
import figureGreen from "../../assets/images/background/figure-green.735ee83d5efa4aacc3c43c627f4626bf.svg"

import closeIcon from "../../assets/images/icons/icono_de_x.svg"
import warningIcon from "../../assets/images/icons/icono de alerta.svg"

import eyeClose from "../../assets/images/icons/ojito_cerrado.svg"
import eyeOpen from "../../assets/images/icons/ojito_abierto.svg"
import emailIcon from "../../assets/images/icons/email.0eead1517e66cbe0eb1a821a83c3b05f.svg"
import padlockIcon from "../../assets/images/icons/candado.svg"

import heartIcon from "../../assets/images/icons/corazon_programate.svg"

export const BACKGROUND_IMAGES = {
    LOGO: logo,
    LINES_GREEN: linesGreen,
    FIGURE_LIGHT_BLUE: figureLightBlue,
    FIGURE_BLUE: figureBlue,
    FIGURE_GREEN: figureGreen,
};

export const MODALS = {
    CLOSE: closeIcon,
    WARNING: warningIcon,
};

export const LOGIN = {
    EYE_CLOSE: eyeClose,
    EYE_OPEN: eyeOpen,
    EMAIL: emailIcon,
    PADLOCK: padlockIcon,
};

export const PROGRAMATE = {
    HEART: heartIcon,
}
